/*
*
* File JS componente Hero Section
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './hero.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const hero = () => {}

export default hero;

//--------------------------------------------------------------------//

document.addEventListener('DOMContentLoaded', function () {
    const mover = document.querySelectorAll('.moving-text .mover');

    mover.forEach((el, i) => {

        el.innerHTML = el.innerHTML.replace(/&nbsp;/g, '');

        const spans = el.querySelectorAll('span');
        const clone = spans[0].cloneNode(true);
        el.appendChild(clone);

        const childs = el.querySelectorAll('span');
        let currentIndex = 0;
    
        setInterval(() => {
            currentIndex++;
            if (currentIndex === childs.length) {
                el.style.transition = 'none';
                el.style.transform = 'translateY(0)';
                setTimeout(() => {
                    el.style.transition = 'transform 1s ease-in-out';
                }, 100);
                currentIndex = 0;
            } else {
                el.style.transform = 'translateY(-' + (currentIndex * 100) + '%)';
            }
        }, 2500);
    });
});